import { AfterViewInit, Component, ElementRef, inject, input, OnInit, QueryList, signal, ViewChildren, WritableSignal } from '@angular/core';
import { Router } from '@angular/router';
import { LanguageService } from '../../Services/language.service';

@Component({
  selector: 'app-learn-more',
  standalone: true,
  imports: [],
  templateUrl: './learn-more.component.html',
  styleUrl: './learn-more.component.scss'
})
export class LearnMoreComponent implements AfterViewInit, OnInit{
 
  router  = inject(Router);
  menuItemID = input.required<number>();
  redirect(menuItemID: number): void {
    this.router.navigate(['/singleItem', menuItemID]);
  }
  private languageService = inject(LanguageService);
  language = this.languageService.getLanguage();
  LearnMore: WritableSignal<string> = signal('');
  

  

  //for aniamtions
  @ViewChildren('container') containers!: QueryList<ElementRef>; // Query all containers

  ngOnInit(): void {
    this.languageService.currentLanguage$.subscribe(() => {
      this.updateTitles();
    });
  }


  ngAfterViewInit(): void {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active'); // Add the 'active' class
            entry.target.classList.remove('inactive'); // Remove the 'inactive' class
            observer.unobserve(entry.target); // Stop observing once it's visible
          }
        });
      },
      { threshold: 0.2 } // Trigger when 20% of the element is visible
    );

    // Observe each container
    this.containers.forEach(container => {
      observer.observe(container.nativeElement);
    });
  }

  updateTitles(){
    this.language = this.languageService.getLanguage();
    this.LearnMore = this.languageService.LearnMore;
  }


}
